export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/internalcontrol/bill',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/internalcontrol/bill',
      method: 'POST'
    }]
  },
  check: {
    funKey: 'check',
    name: '系统校验',
    apis: [{
      path: '/internalcontrol/bill/check/{id}',
      method: 'POST'
    }]
  },
  manual_check: {
    funKey: 'manual_check',
    name: '人工校验',
    apis: [{
      path: '/internalcontrol/bill/manual_check/{id}',
      method: 'POST'
    }]
  },
  re_check: {
    funKey: 're_check',
    name: '重新校验',
    apis: [{
      path: '/internalcontrol/bill/manual_check/{id}',
      method: 'POST'
    }]
  },
  check_record: {
    funKey: 'check_record',
    name: '系统校验记录',
    apis: [{
      path: '/internalcontrol/bill/check',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/internalcontrol/bill/{id}',
      method: 'PUT'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/internalcontrol/bill/{id}',
      method: 'DELETE'
    }]
  },
  data_file: {
    funKey: 'data_file',
    name: '扫描件'
  },
  getDataFile: {
    funKey: 'getDataFile',
    name: '获取扫描件'
  },
  updateDataFile: {
    funKey: 'updateDataFile',
    name: '上传扫描件'
  },
  downDataFile: {
    funKey: 'downDataFile',
    name: '下载扫描件'
  },
  delDataFile: {
    funKey: 'delDataFile',
    name: '删除扫描件'
  }
}